<!--机器人问答：表单方式收集信息, 对应老webim: type=13 -->
<template>
  <popup ref="popup" :show.sync="openPop" title="请填写以下信息" :showClose="false">
    <div>
      <form class="robot-form" @submit.prevent="onSubmit">
        <div
          v-for="(item, index) in formData"
          :key="index"
          class="item-line"
        >
          <div class="item-header">
            <label>
              <div class="label-title">{{ item.fieldName }}</div>
              <div v-if="item.required" class="label-icon">*</div>
              <div class="label-desc"></div>
            </label>
            <span class="error-txt">{{ item.error || '' }}</span>
          </div>
          <div v-if="TYPE_MAPPER[item.fieldType] === 'enum_single'" :class="[item.value ? '' :'select-placeholder']">
            <select
            v-model="item.value"
            placeholder="请选择"
          >
            <option
              v-for="opt in item.options"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.text }}
            </option>
          </select>
          </div>
          <input
            v-else
            v-model="item.value"
            type="text"
            placeholder="请输入"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            @blur="checkItem(item)"
          />
        </div>

        <div class="btn-box">
          <button type="submit" class="primary">
            {{ vm.$t('chat_feedback_submit_text') }}
          </button>
          <button @click="closePop">
            {{ vm.$t('common_cancel_text') }}
          </button>
        </div>
      </form>
    </div>
  </popup>
</template>

<script>
import Popup from '@/components/Popup';
import { handleLinkClick } from '@/utils/bindlLinkClick';

const TYPE_MAPPER = {
  1: 'enum_single', // 下拉单选
  2: 'string', // 文本
  3: 'int', // 数字
};
export default {
  components: { Popup },
  props: {
    data: {
      default: Object,
    },
    // i18n this访问问题
    vm: {
      type: Object,
    },
  },
  data() {
    let { content } = this.data.content;
    try {
      // 转义一次，因为这里的content可能是个字符串
      content = JSON.parse(content);
    } catch (ex) {}
    console.log('[RobotForm]', content);

    const formData = content.map((item) => {
      // 更新options
      const oldOpt = item.options.instances;
      // eslint-disable-next-line no-param-reassign
      item.options = oldOpt.map(opt => ({
        text: opt.name,
        value: opt.name,
      }));

      this.$set(item, 'value', '');
      // 默认选中第一个
      // if (TYPE_MAPPER[item.fieldType] === 'enum_single') {
      //   this.$set(item, 'value', item.options[0].value);
      // }

      return item;
    });
    return {
      openPop: false,
      TYPE_MAPPER,
      formData,
    };
  },
  mounted() {
    setTimeout(() => {
      this.openPop = true;
    }, 400);
  },
  methods: {
    closePop() {
      this.$refs.popup.close();
    },

    // 检测格式
    checkItem(item) {
      const maxLen = 3 === item.fieldType ? 20 : 200;

      if (item.required && item.value.length === 0) {
        this.$set(item, 'error', `${item.fieldName}不能为空`);
        return false;
      }

      if (item.fieldType === 3 && (item.value.length > maxLen || !/^\d+$/.test(item.value))) {
        // 如果不是必填并且用户没有填的话，就可以过，只要填了就必须格式正确，不管是否必填
        if (!item.required && !item.value) {
          this.$set(item, 'error', '');
          return true;
        }
        this.$set(item, 'error', `请您填写数字，最大长度为${maxLen}`);
        return false;
      }

      if (item.value.length > maxLen) {
        this.$set(item, 'error', `${item.fieldName}最长长度不能超过${maxLen}`);
        return false;
      }

      this.$set(item, 'error', '');
      return true;
    },

    // 提交
    onSubmit() {
      const hasError = this.formData.some(item => this.checkItem(item) === false);
      if (hasError) {
        return false;
      }

      const rs = { slot: {}, field: {} };
      this.formData.forEach((item) => {
        const val = item.value;

        rs.slot[item.slotName] = val;
        rs.field[item.fieldName] = val;
      });

      console.log('[robot-form]', rs);
      this.closePop();
      // eslint-disable-next-line camelcase
      const { crm: { msg_webim_extra_data: { uint64_robotid = '', bytes_wpaid = '' } }  } = this.data;
      // 数据提交，通过 innerClickEvent实现。
      // eslint-disable-next-line camelcase
      const cmdUrl = `mqqwpa://im/qdmenu?svrId=1000003&ext=${JSON.stringify(rs)}&robotId=${uint64_robotid}&extType=3&wpaId=${bytes_wpaid}`;
      handleLinkClick(cmdUrl);
    },
  },
};
</script>

<style lang="less" scoped>
.robot-form {
  padding: 0 20px;

  .item-line {
    margin-bottom: 30px;
    box-sizing: border-box;
    font-size: 14px;

    .item-header {
      margin-bottom: 11px;
      // height: 20px;
      line-height: 20px;
      font-size: 16px;
    }

    .label-title,
    .label-icon,
    .label-desc {
      display: inline-block;
    }

    .label-title {
      line-height: 20px;
      font-size: 16px;
      font-weight: 700;
      color: #222;
    }

    .label-icon{
      color: #f00;
    }

    .error-txt{
      display: inline;
      font-size: 14px;
      color: #ff4222;
      cursor: text;
      // white-space: nowrap;
      line-height: 20px;
      margin-left: 10px;
    }
  }

  input,
  select {
    position: relative;
    display: block;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    padding: 2px 8px;
    border: 1px solid #dadee7;
    border-radius: 2px;
    transition: border-color 0.25s;
    outline: none;
    background: #FFFFFF;
    &.is-invalid {
      border-color: #ff4222;
    }
  }
  .select-placeholder {
    position: relative;
  }
  .select-placeholder::after {
    content:"请选择";
    color: #6a6a6a;
    display:inline-block;
    position: absolute;
    top: 12px;
    left: 11px;
  }

  .btn-box{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;

    button{
      width: 80px;
      height: 40px;
      cursor: pointer;
      font-size: 14px;
      line-height: 38px;
      border: 1px solid #dadee7;
      box-sizing: border-box;
      background: #fff;

      &:not(:first-child) {
        margin-left: 10px;
        color:#1e2330
      }

      &.primary{
        color: #fff;
        border: 1px solid @primary;
        background-color: @primary;
      }
    }
  }
}
</style>
